import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TrafficTypeItem from '../TrafficTypeItem/TrafficTypeItem';
import { Star } from 'react-feather';
import ReactTooltip from 'react-tooltip';
import AffiliateCampaignStatus from '../AffiliateCampaignStatus/AffiliateCampaignStatus';
import CountryList from '../../../data/countrylist.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic } from '@fortawesome/free-solid-svg-icons';

import './CampaignInfo.css'

class CampaignInfo extends Component {

    _isMounted = false;

    state = {
        expandCountries: false,
        isCampaignBookmarked: false        
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ isCampaignBookmarked: this.props.data.is_bookmarked });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getTrafficTypes = () => {
        const { allowed_traffic_types } = this.props.data;
        let rows = [];

        for (var key in allowed_traffic_types) {
            rows.push(<TrafficTypeItem key={key} trafficType={key} allowed={allowed_traffic_types[key]} type="description" />)
        }

        return rows;
    }

    formatDaypartingLabel = (dayLabel = '') => {
        return dayLabel
            .split('-')
            .map(day => day.charAt(0).toUpperCase() + day.slice(1))
            .join(' - ');
    }

    formatMinutesToTime = (totalMinutes) => {
        if (typeof totalMinutes !== 'number' || Number.isNaN(totalMinutes)) {
            return '';
        }

        const normalizedMinutes = ((totalMinutes % 1440) + 1440) % 1440;
        const hours = Math.floor(normalizedMinutes / 60);
        const minutes = normalizedMinutes % 60;
        const period = hours >= 12 ? 'PM' : 'AM';
        const twelveHour = (hours % 12) || 12;
        const formattedMinutes = minutes.toString().padStart(2, '0');

        return `${twelveHour}:${formattedMinutes} ${period}`;
    }

    daypartingArrayToLegacy = (daypartingArray) => {
        const DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

        if (!Array.isArray(daypartingArray) || daypartingArray.length === 0) {
            return {};
        }

        // Build per-day slot lists, preserving sorted order.
        const scheduleByDay = {};
        DAY_NAMES.forEach((dayName) => {
            scheduleByDay[dayName] = [];
        });

        daypartingArray.forEach(({ day_name, start_time_minute, end_time_minute }) => {
            if (!scheduleByDay[day_name]) {
                return;
            }

            scheduleByDay[day_name].push({ start_time_minute, end_time_minute });
        });

        // Signature = JSON of sorted slots (used to detect matching days).
        const signature = (slots) => JSON.stringify(
            [...slots].sort((a, b) => a.start_time_minute - b.start_time_minute)
        );

        const signatures = {};
        DAY_NAMES.forEach((dayName) => {
            signatures[dayName] = signature(scheduleByDay[dayName]);
        });

        const legacy = {};
        let i = 0;

        while (i < DAY_NAMES.length) {
            const currentDay = DAY_NAMES[i];
            const slots = scheduleByDay[currentDay];

            if (slots.length === 0) {
                i++;
                continue;
            }

            let j = i;
            while (
                j + 1 < DAY_NAMES.length &&
                scheduleByDay[DAY_NAMES[j + 1]].length > 0 &&
                signatures[DAY_NAMES[j + 1]] === signatures[currentDay]
            ) {
                j++;
            }

            const key = j > i ? `${DAY_NAMES[i]}-${DAY_NAMES[j]}` : currentDay;
            legacy[key] = slots;
            i = j + 1;
        }

        return legacy;
    }

    getDaypartingInfo = () => {
        const daypartingSource = this.props.dayparting || this.props.data.dayparting;
        const dayparting = Array.isArray(daypartingSource)
            ? this.daypartingArrayToLegacy(daypartingSource)
            : daypartingSource;

        if (!dayparting || typeof dayparting !== 'object') {
            return null;
        }

        const daypartingKeys = Object.keys(dayparting);
        if (!daypartingKeys.length) {
            return null;
        }

        return daypartingKeys.map(dayKey => {
            const ranges = Array.isArray(dayparting[dayKey]) ? dayparting[dayKey] : [];
            if (!ranges.length) {
                return null;
            }

            const formattedRanges = ranges
                .map(range => `${this.formatMinutesToTime(range.start_time_minute)} - ${this.formatMinutesToTime(range.end_time_minute)}`)
                .join(', ');

            return (
                <div key={dayKey}>
                    <span className="font-weight-bold">{this.formatDaypartingLabel(dayKey)}:</span> {formattedRanges}
                </div>
            );
        });
    }

    getcountryList = () => {
        // Get the entire list of countries from the endpoint
        // Also need to determine if we're on the last country in the array, if we are, we don't put a comma
        let list = '';
        let arrayLen = this.props.data.allowed_countries.length;
        let count = 0;
        let separator = ', ';
        this.props.data.allowed_countries.map(country_code => {
            count = count + 1;
            if (count === arrayLen) {
                separator = '';
            }
            return CountryList.countries.filter(country => (country.code === country_code))[0] &&
                (list = list + CountryList.countries.filter(country => (country.code === country_code))[0].name + separator);
        });
        return list;
    }

    expandCountries = () => {
        if (this._isMounted) {
            this.setState({
                expandCountries: !this.state.expandCountries
            });
        }
    }

    getOSlist = () => {

        const { details, os_list } = this.props.data;
        let rows = [];

        if (details.os_filtering === 'Y') {
            os_list.map(os => {
                let displayedOS;
                if (os === 'iOS') {
                    displayedOS = <FontAwesomeIcon icon={['fab', 'apple']} />;
                } else if (os === 'Android') {
                    displayedOS = 'Android';
                }
                return rows.push(<React.Fragment key={os}>{displayedOS} {os}</React.Fragment>)
            });
        } else {
            if (details.desktop_traffic !== 'Y') {
                rows = 'All mobile operating system allowed';
            } else {
                rows = 'All device operating systems allowed';
            }
        }
        return rows;
    }

    bookmarkToggleHandler = () => {
        const authtoken = localStorage.getItem('mb-auth-token');

        if (this.state.isCampaignBookmarked) {
            fetch(`${process.env.REACT_APP_API_URL}/campaign/${this.props.data.campaign_id}/removeBookmark`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'x-app-token': authtoken
                }
            })
                .then(res => res.json())
                .then(result => {
                    if (result["success"] === true) {
                        if (this._isMounted) {
                            this.setState({ isCampaignBookmarked: false });
                        }
                    } else if (result["success"] === false) {
                        if (this._isMounted) {
                            this.setState({ isCampaignBookmarked: this.state.isCampaignBookmarked });
                        }
                    } else {
                        this.props.showSystemMessage("error", result.errors.message);
                    }
                }).catch(error => {
                    this.props.showSystemMessage("error", error);
                });
        } else {
            fetch(`${process.env.REACT_APP_API_URL}/campaign/${this.props.data.campaign_id}/addBookmark`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'x-app-token': authtoken
                }
            })
                .then(res => res.json())
                .then(result => {
                    if (result["success"] === true) {
                        if (this._isMounted) {
                            this.setState({ isCampaignBookmarked: true });
                        }
                    } else if (result["success"] === false) {
                        if (this._isMounted) {
                            this.setState({ isCampaignBookmarked: this.state.isCampaignBookmarked });
                        }
                    } else {
                        this.props.showSystemMessage("error", result.errors.message);
                    }
                }).catch(error => {
                    this.props.showSystemMessage("error", error.message);
                });
        }
    }

    render() {

        const { campaign_id, allowed_countries, details, categories } = this.props.data;
        const daypartingInfo = this.getDaypartingInfo();

        // The classes for the country section will change depending on whether it's expanded or not.
        let countryClasses = 'position-relative country-container';
        let countryOverlayClasses = 'position-absolute text-center country-overlay';
        let countryCountIsBig = 5;

        if (this.state.expandCountries) {
            countryClasses = 'position-relative country-container open';
            countryOverlayClasses = 'position-absolute text-center country-overlay open';
        } else {
            if (allowed_countries.length > countryCountIsBig) {
                countryClasses = 'position-relative country-container closed';
            } else {
                countryClasses = 'position-relative country-container closed short';
            }
            countryOverlayClasses = 'position-absolute text-center country-overlay closed';
        }

        let bookmarkButtonText = this.state.isCampaignBookmarked ? "Remove Bookmark" : "Bookmark";
        let bookmarkButtonClasses = this.state.isCampaignBookmarked ? "btn btn-sm btn-warning" : "btn btn-sm btn-outline-warning";

        return (
            <div className="card my-2">                           
                <div className="card-header d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                        Campaign Information
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                        <button type="button" className={bookmarkButtonClasses} onClick={this.bookmarkToggleHandler}>
                            <Star size={20} style={{ paddingRight: "3px", paddingBottom: "3px" }} />
                            {bookmarkButtonText}
                        </button>
                    </div>
                </div>
                <div className="card-body p-0">
                    <div className="campaign-image border-bottom" >
                        <img
                            className="w-100"
                            src={`${details.thumbnail}`}
                            alt="Landing Page Screenshot" />
                    </div>
                    <div className="d-flex flex-wrap p-2">
                        <div className="flex-1"><span className="font-weight-bold">{details.name}</span> <span className="text-secondary">ID: {campaign_id}</span></div>
                        <div>
                            <Link to={`/search?st=&ob=date&ep=true&cp=true&bp=true&sp=true&ip=true&lp=true&np=true&mp=true&bbp=true&tstrict=0&gr=&grstrict=0&m=${categories.main_category_id}&c=0&af=false&ff=false&rf=false&ar=false&as=true&ct=&pn=1`}>{categories.category} </Link>
                            -                            <Link to={`/search?st=&ob=date&ep=true&cp=true&bp=true&sp=true&ip=true&lp=true&np=true&mp=true&bbp=true&tstrict=0&gr=&grstrict=0&m=${categories.main_category_id}&c=${categories.subcategory_id}&af=false&ff=false&rf=false&ar=false&as=true&ct=&pn=1`}>                        {categories.subcategory}</Link>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-card">
                                <tbody>
                                    <tr>
                                        <td>Allowed Traffic Types</td>
                                        <td>{this.getTrafficTypes()}</td>
                                    </tr>
                                    {daypartingInfo && (
                                        <tr>
                                            <td>Schedule</td>
                                            <td>
                                                <div className="alert alert-info">
                                                    This campaign will only be active during the times listed below. Times are in Eastern Time (ET).
                                                </div>                                                
                                                {daypartingInfo}                                                
                                            </td>
                                        </tr>
                                    )}
                                    {
                                        this.props.data.details.status == 'Paused' &&
                                            <tr>
                                                <td>Status</td>
                                                <td>
                                                    <span className="badge badge-warning">Currently Paused - See schedule above for details</span>
                                                </td>
                                            </tr>                                            
                                    }
                                    <tr>
                                        <td>Your Status</td>
                                        <td>
                                            <AffiliateCampaignStatus
                                                mode="text"
                                                toggleModal={this.props.toggleModal}
                                                data={this.props.data}
                                                showSystemMessage={this.props.showSystemMessage} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Your Daily Cap</td>
                                        <td>{this.props.data.details.cap}</td>
                                    </tr>
                                    <tr>
                                        <td>Countries Allowed</td>
                                        <td>
                                            <div className={countryClasses}>
                                                {allowed_countries.length > countryCountIsBig && (
                                                    <div className={countryOverlayClasses}>
                                                        <button className="btn btn-link btn-sm" onClick={this.expandCountries}>
                                                            {this.state.expandCountries ? <span>See Less</span> : <span>See More</span>}
                                                        </button>
                                                    </div>
                                                )}
                                                {details.geo_filtering === 'Y' ?
                                                    this.getcountryList()
                                                    :
                                                    <React.Fragment>Traffic allowed from all countries</React.Fragment>
                                                }
                                            </div>
                                        </td>{/* props.allowedCountries*/}
                                    </tr>
                                    <tr>
                                        <td>Devices</td>
                                        <td> {this.getOSlist()} </td>
                                    </tr>
                                    {this.props.data.details.payment_delay !== undefined && this.props.data.details.payment_delay !== null && this.props.data.details.payment_delay !== 0 && (
                                        <tr>
                                            <td>Payment Delay</td>
                                            <td>
                                                {`${this.props.data.details.payment_delay} ${this.props.data.details.payment_delay === 1 ? 'day' : 'days'} (${this.props.data.details.payment_delay_mode === 'LEAD_DATE' ? 'from lead date' : 'from end of month'})`}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default CampaignInfo;
